import "./Photos.css";

export default function Photos(props){
    if (props.photos){
      return (
          <div className="Photos">
              <hr className="top-line"/>
              <div className="row">
                {props.photos.map(function(photo, index){
                    return (
                        <div className="col-4" key={index}>
                            <a href={photo.src.original} target="_blank" rel="noreferrer">
                                <img src={photo.src.landscape} alt="" className="img-fluid" />    
                            </a>
                        </div> 
                    )
                })}  
              </div>
              <hr className="bottom-line"/>
          </div>
      )  
    } else {
        return null;
    }
    
}